import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import CN from "./locales/CN.json";
import EN from "./locales/EN.json";

export enum LANGUAGE {
	EN = "en",
	CN = "cn",
}

export const LANGUAGES = [
	{ value: LANGUAGE.EN, label: "English" },
	{ value: LANGUAGE.CN, label: "中文" },
];

const resources = {
	[LANGUAGE.EN]: {
		translation: EN,
	},
	[LANGUAGE.CN]: {
		translation: CN,
	},
};

i18n.use(initReactI18next).init({
	resources,
	lng: LANGUAGE.EN, // default language
	fallbackLng: LANGUAGE.EN,
	interpolation: {
		escapeValue: false, // React already does escaping
	},
});

export default i18n;
